export enum AccountSorting {
  LIST_BRAND_REP_STATUS = 'LIST_BRAND_REP_STATUS',
  LIST_BRAND_REP_FIRST_NAME = 'LIST_BRAND_REP_FIRST_NAME',
  LIST_BRAND_REP_LAST_NAME = 'LIST_BRAND_REP_LAST_NAME',
  LIST_BRAND_REP_ROLE_NAME = 'LIST_BRAND_REP_ROLE_NAME',
  LIST_BRAND_REP_ROLE_BRAND = 'LIST_BRAND_REP_ROLE_BRAND',
}
